export const ADD_UPDATE_STORE_START = 'ADD_UPDATE_STORE_START';
export const ADD_UPDATE_STORE_SUCCESS = 'ADD_UPDATE_STORE_SUCCESS';
export const ADD_UPDATE_STORE_ERROR = 'ADD_UPDATE_STORE_ERROR';
export const ADD_UPDATE_STORE_END = 'ADD_UPDATE_STORE_END';
export const CLEAR_ADD_UPDATE_STORE_STORE =
  'CLEAR_ADD_UPDATE_STORE_STORE';
